import script from "./ArchiveItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveItem.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__